  export const diseases = [
    {
      label: 'Asthma',
      label_show: 'Asthma',
      page: 13,
      Xpos_image: '296px',
      Ypos_image: '480px',
      Xlabel: '309px',
      Ylabel: '555px',
      width: '70px',
      height: 'auto',
      result_comp: [
        { min: 0, max: 3, image: 'asthma_0' },
        { min: 4, max: 6, image: 'asthma_1' },
        { min: 7, max: 100, image: 'asthma_2' }
      ]
    },
    {
        label: 'Food allergy',
        label_show: 'Food Allergy',
        page: 13,
        Xpos_image: '559px',
        Ypos_image: '480px',
        Xlabel: '561px',
        Ylabel: '555px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'foodallergy_0' },
          { min: 4, max: 6, image: 'foodallergy_1' },
          { min: 7, max: 100, image: 'foodallergy_2' }
        ]
      },
      {
        label: 'Eczema',
        label_show: 'Eczema',
        page: 13,
        Xpos_image: '428px',
        Ypos_image: '480px',
        Xlabel: '442px',
        Ylabel: '555px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'eczema_0' },
          { min: 4, max: 6, image: 'eczema_1' },
          { min: 7, max: 100, image: 'eczema_2' }
        ]
      },
      {
        label: 'Allergic rhinitis',
        label_show: 'Allergic Rhinitis',
        page: 13,
        Xpos_image: '165px',
        Ypos_image: '480px',
        Xlabel: '159px',
        Ylabel: '555px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'allergicrhiniitis_0' },
          { min: 4, max: 6, image: 'allergicrhiniitis_1' },
          { min: 7, max: 100, image: 'allergicrhiniitis_2' }
        ]
      },
      {
        label: 'Overweight',
        label_show: 'Obesity',
        page: 13,
        Xpos_image: '296px',
        Ypos_image: '605px',
        Xlabel: '309px',
        Ylabel: '680px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'overweight_0' },
          { min: 4, max: 6, image: 'overweight_1' },
          { min: 7, max: 100, image: 'overweight_2' }
        ]
      },
      {
        label: 'Metabolic syndrome',
        label_show: 'Dyslipidemia',
        page: 13,
        Xpos_image: '165px',
        Ypos_image: '605px',
        Xlabel: '165px',
        Ylabel: '680px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'metabolicsyndrome_0' },
          { min: 4, max: 6, image: 'metabolicsyndrome_1' },
          { min: 7, max: 100, image: 'metabolicsyndrome_2' }
        ]
      },
      {
        label: 'Type 2 diabetes',
        label_show: ['Type 2', 'Diabetes'],
        page: 13,
        Xpos_image: '428px',
        Ypos_image: '605px',
        Xlabel: '438px',
        Ylabel: '680px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'type2diabetes_0' },
          { min: 4, max: 6, image: 'type2diabetes_1' },
          { min: 7, max: 100, image: 'type2diabetes_2' }
        ]
      },
      {
        label: 'Excessive lipopolysaccharide',
        label_show: ['Excessive', 'Lipopolysaccharide'],
        page: 13,
        Xpos_image: '559px',
        Ypos_image: '605px',
        Xlabel: '541px',
        Ylabel: '680px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'excessivelipopolysaccharide_0' },
          { min: 4, max: 6, image: 'excessivelipopolysaccharide_1' },
          { min: 7, max: 100, image: 'excessivelipopolysaccharide_2' }
        ]
      },
      {
        label: 'Constipation',
        label_show: 'Constipation',
        page: 13,
        Xpos_image: '230px',
        Ypos_image: '731px',
        Xlabel: '230px',
        Ylabel: '806px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'constipation_0' },
          { min: 4, max: 6, image: 'constipation_1' },
          { min: 7, max: 100, image: 'constipation_2' }
        ]
      },
      {
        label: 'Diarrhea',
        label_show: 'Diarrhea',
        page: 13,
        Xpos_image: '361px',
        Ypos_image: '731px',
        Xlabel: '373px',
        Ylabel: '806px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'diarrhea_0' },
          { min: 4, max: 6, image: 'diarrhea_1' },
          { min: 7, max: 100, image: 'diarrhea_2' }
        ]
      },
      {
        label: 'Immune disorder',
        label_show: 'Immune Dysfunction',
        page: 13,
        Xpos_image: '493px',
        Ypos_image: '731px',
        Xlabel: '471px',
        Ylabel: '806px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'immunedisorder_0' },
          { min: 4, max: 6, image: 'immunedisorder_1' },
          { min: 7, max: 100, image: 'immunedisorder_2' }
        ]
      },
      {
        label: 'Insomnia/ poor sleep quality',
        label_show: ['Insomnia/ Poor', 'Sleep quality'],
        page: 13,
        Xpos_image: '295px',
        Ypos_image: '858px',
        Xlabel: '287px',
        Ylabel: '933px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'insommnia_0' },
          { min: 4, max: 6, image: 'insommnia_1' },
          { min: 7, max: 100, image: 'insommnia_2' }
        ]
      },
      {
        label: 'Stress and anxiety',
        label_show: ['Stress and', 'Anxiety'],
        page: 13,
        Xpos_image: '426px',
        Ypos_image: '858px',
        Xlabel: '431px',
        Ylabel: '933px',
        width: '70px',
        height: 'auto',
        result_comp: [
          { min: 0, max: 3, image: 'stress_0' },
          { min: 4, max: 6, image: 'stress_1' },
          { min: 7, max: 100, image: 'stress_2' }
        ]
      },
  ];
  
  export const diseases_image = [

    // Page 12
    {
      label: 'Asthma',
      label_show: '',
      page: 16,
      Xpos_image: '50px',
      Ypos_image: '852px',
      Xlabel: '90px',
      Ylabel: '757px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Food allergy',
      label_show: '',
      page: 16,
      Xpos_image: '50px',
      Ypos_image: '1005px',
      Xlabel: '79px',
      Ylabel: '859px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Eczema',
      label_show: '',
      page: 16,
      Xpos_image: '50px',
      Ypos_image: '928px',
      Xlabel: '90px',
      Ylabel: '961px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Allergic rhinitis',
      label_show: '',
      page: 16,
      Xpos_image: '50px',
      Ypos_image: '777px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    {
      label: 'Allergic rhinitis',
      label_show: '',
      page: 17,
      Xpos_image: '50px',
      Ypos_image: '136px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 13
    {
      label: 'Asthma',
      label_show: '',
      page: 18,
      Xpos_image: '50px',
      Ypos_image: '136px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 14
    {
      label: 'Food allergy',
      label_show: '',
      page: 20,
      Xpos_image: '50px',
      Ypos_image: '136px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 15
    {
      label: 'Eczema',
      label_show: '',
      page: 19,
      Xpos_image: '50px',
      Ypos_image: '136px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 16
    // {
    //   label: 'Allergic rhinitis',
    //   label_show: '',
    //   page: 16,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 18
    // {
    //   label: 'Overweight',
    //   label_show: 'Overweight',
    //   page: 18,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '81px',
    //   Ylabel: '316px',
    //   width: '70px',
    //   height: 'auto'
    // },
    // {
    //   label: 'Metabolic syndrome',
    //   label_show: ['Metabolic', 'syndrome'],
    //   page: 18,
    //   Xpos_image: '77px',
    //   Ypos_image: '358px',
    //   Xlabel: '85px',
    //   Ylabel: '430px',
    //   width: '70px',
    //   height: 'auto'
    // },
    {
      label: 'Type 2 diabetes',
      label_show: '',
      page: 27,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Excessive lipopolysaccharide',
      label_show: '',
      page: 24,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 19
    // {
    //   label: 'Overweight',
    //   label_show: '',
    //   page: 19,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 20
    // {
    //   label: 'Metabolic syndrome',
    //   label_show: '',
    //   page: 20,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 21
    // {
    //   label: 'Type 2 diabetes',
    //   label_show: '',
    //   page: 21,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },

    // Page 22
    {
      label: 'Excessive lipopolysaccharide',
      label_show: '',
      page: 22,
      Xpos_image: '50px',
      Ypos_image: '155px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Metabolic syndrome',
      label_show: '',
      page: 22,
      Xpos_image: '50px',
      Ypos_image: '80px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Overweight',
      label_show: '',
      page: 22,
      Xpos_image: '50px',
      Ypos_image: '231px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Type 2 diabetes',
      label_show: '',
      page: 22,
      Xpos_image: '50px',
      Ypos_image: '308px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 23
    {
      label: 'Metabolic syndrome',
      label_show: '',
      page: 23,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    {
      label: 'Diarrhea',
      label_show: '',
      page: 30,
      Xpos_image: '50px',
      Ypos_image: '158px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Diarrhea',
      label_show: '',
      page: 32,
      Xpos_image: '50px',
      Ypos_image: '130px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Immune disorder',
      label_show: '',
      page: 30,
      Xpos_image: '50px',
      Ypos_image: '235px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 24
    {
      label: 'Constipation',
      label_show: '',
      page: 30,
      Xpos_image: '50px',
      Ypos_image: '81px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
    {
      label: 'Constipation',
      label_show: '',
      page: 30,
      Xpos_image: '50px',
      Ypos_image: '391px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 25
    {
      label: 'Overweight',
      label_show: '',
      page: 25,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 26
    {
      label: 'Immune disorder',
      label_show: '',
      page: 34,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 27
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: '',
      page: 36,
      Xpos_image: '50px',
      Ypos_image: '1000px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    {
      label: 'Stress and anxiety',
      label_show: '',
      page: 36,
      Xpos_image: '50px',
      Ypos_image: '925px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 28
    // {
    //   label: 'Insomnia/ poor sleep quality',
    //   label_show: '',
    //   page: 28,
    //   Xpos_image: '77px',
    //   Ypos_image: '245px',
    //   Xlabel: '73px',
    //   Ylabel: '1065px',
    //   width: '70px',
    //   height: 'auto'
    // },
    {
      label: 'Insomnia/ poor sleep quality',
      label_show: '',
      page: 38,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },

    // Page 29
    {
      label: 'Stress and anxiety',
      label_show: '',
      page: 37,
      Xpos_image: '50px',
      Ypos_image: '134px',
      Xlabel: '73px',
      Ylabel: '1065px',
      width: '70px',
      height: 'auto'
    },
  ];